import $ from 'jquery';
import { Fancybox } from '@fancyapps/ui';
import Cookies from 'js-cookie';
import 'sharer.js';

const jsContainer = () => {
    if ($('.js-container').length) {
        const bodyWidth = $('body').outerWidth();
        $('.js-container').css({
            width: bodyWidth,
            marginLeft: `calc(${-bodyWidth / 2}px + 50%)`,
        });
    }
};

const headerPadding = () => {
    const headerHeight = $('.site-header').outerHeight();

    if (window.matchMedia('(max-width: 767.98px)').matches) {
        $('.site').css('padding-top', headerHeight - 30);
    } else {
        $('.site').css('padding-top', headerHeight);
    }
};

$(window)
    .on('resize', function () {
        jsContainer();
        headerPadding();
    })
    .trigger('resize');

$('.vn-btn-terms button').on('click', function (e) {
    e.preventDefault();
    const button = $(this);
    const href = button.attr('data-url');

    window.location.href = href;
});

$('a[href="#cookies"]').on('click', (e) => {
    e.preventDefault();
    window.openAxeptioCookies();
});

$('.wp-block-gallery').each(function (i) {
    $(this).attr('data-block-gallery', i);
    const items = $(`[data-block-gallery=${i}]`).find('a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"]');
    items.attr('data-fancybox', `block-gallery-${i}`);

    Fancybox.bind(`[data-block-gallery=${i}]`);
});

$('.sticky-event__closer').on('click', function () {
    const event = $('.sticky-event');
    event.toggleClass('sticky-event--active');
    $(this).find('i').toggleClass('halles610-icons-close halles610-icons-star');

    Cookies.set('stickyEventActive', event.hasClass('sticky-event--active') ? 1 : 0);
});

$('.blog-filter__select').on('change', function () {
    window.location.href = $(this).val();
});
